// extracted by mini-css-extract-plugin
module.exports = {"logoSvg":"Logo_logoSvg__Y4SyF","logoText":"Logo_logoText__sUBnc","logoTextSlim":"Logo_logoTextSlim__2Fcfm","logoTextMom":"Logo_logoTextMom__1yHph"};